module.exports = __webpack_public_path__ + "img/speed.df9b5110.png";